(function ($) {
  'use strict';

  const SELECTORS = {
    container: '.tabs-container',
    listWrapper: '.tabs-list-wrapper',
    list: '.tabs-list',
    tab: '.tab',
    panelsWrapper: '.tabs-panels-wrapper',
    panel: '.tab-panel',
    tabContainer: '[data-tab-container]',
    tabToggle: '[data-toggle="tab"]',
    videoLink: '.video-item__link',
    videoModal: '.video-modal',
    videoModalInner: '.js-video-modal',
    closeModal: '.js-close-modal',
  };

  const ACTIVE_CLASS = 'is-active';

  function getTransitionEndEvent() {
    const el = document.createElement('div');
    const transitions = {
      transition: 'transitionend',
      OTransition: 'oTransitionEnd',
      MozTransition: 'transitionend',
      WebkitTransition: 'webkitTransitionEnd',
    };
    for (const [prop, event] of Object.entries(transitions)) {
      if (el.style[prop] !== undefined) return event;
    }
  }

  class Tabs {
    constructor(element, tabStyle) {
      const $el = $(element);

      this.name = 'tabs';
      this.namespace = '.' + this.name;
      this.tabStyle = tabStyle || 'tabs';
      this.events = {
        HIDDEN: 'hidden' + this.namespace,
        HIDE: 'hide' + this.namespace,
        SHOW: 'show' + this.namespace,
        SHOWN: 'shown' + this.namespace,
      };
      this.animationDuration = 300;
      this.transitionEndEvent = getTransitionEndEvent();
      this.supportsCssTransitions = !!(window.Modernizr && Modernizr.csstransitions);
      this.isAnimating = false;

      if (!$el.length || !$el.is(SELECTORS.container)) {
        console.warn(`[${this.name}] - Tabs container element required to initialize`);
        return;
      }

      this.$el = $el;
      this.$tabs = $(SELECTORS.tab, this.$el);
      this.$tabsList = $(SELECTORS.list, this.$el);
      this.$tabsListWrapper = $(SELECTORS.listWrapper, this.$el);
      this.$tabPanels = $(SELECTORS.panel, this.$el);
      this.$tabsPanelsWrapper = $(SELECTORS.panelsWrapper, this.$el);
      this.$activeTab = this.$tabs.filter('.' + ACTIVE_CLASS);
      this.$activeTabPanel = this.$tabPanels.filter('.' + ACTIVE_CLASS);

      const required = ['tabs', 'tabsList', 'tabsListWrapper', 'tabPanels', 'tabsPanelsWrapper'];
      const missing = required.filter((key) => this['$' + key].length === 0);

      if (missing.length > 0) {
        missing.forEach((key) => {
          console.warn(`[${this.name}] - "this.$${key}" element required to initialize`);
        });
        return;
      }

      this.$el.on('click' + this.namespace, SELECTORS.tab, this.onTabClick.bind(this));

      if (this.$activeTab.length === 0) {
        this.activate(this.$tabs.first());
      }
    }

    activate($tab) {
      if (!$tab || !$tab.length || $tab.hasClass(ACTIVE_CLASS) || $tab.is(this.$activeTab) || this.isAnimating) {
        return;
      }

      if (this.$activeTab && this.$activeTab.length) {
        this.$activeTab.removeClass(ACTIVE_CLASS).parent().removeClass(ACTIVE_CLASS);
        if (this.$activeTab.attr('role') === 'tab') {
          this.$activeTab.attr('aria-selected', false);
        }
      }

      $tab.addClass(ACTIVE_CLASS).parent().addClass(ACTIVE_CLASS);
      if ($tab.attr('role') === 'tab') {
        $tab.attr('aria-selected', true);
      }

      const $panel = $($tab.attr('href'));

      if (this.tabStyle === 'pdp') {
        const showNewPanel = () => {
          if (this.$activeTabPanel && this.$activeTabPanel.length) {
            this.$el.trigger($.Event(this.events.HIDDEN, { relatedTarget: this.$activeTabPanel.get(0) }));
          }

          this.$el.trigger($.Event(this.events.SHOW, { relatedTarget: $panel.get(0) }));
          $panel.addClass(ACTIVE_CLASS);
          this.$tabsPanelsWrapper.css('height', $panel.height());
          this.$activeTab = $tab;
          this.$activeTabPanel = $panel;

          const onShown = () => {
            this.$el.trigger($.Event(this.events.SHOWN, { relatedTarget: $panel.get(0) }));
            this.isAnimating = false;
          };

          if (this.supportsCssTransitions) {
            this.$activeTabPanel.one(this.transitionEndEvent, onShown);
          } else {
            setTimeout(onShown, this.animationDuration);
          }
        };

        if (this.$activeTabPanel && this.$activeTabPanel.length) {
          this.$el.trigger($.Event(this.events.HIDE, { relatedTarget: this.$activeTabPanel.get(0) }));
          this.$activeTabPanel.removeClass(ACTIVE_CLASS);
          this.isAnimating = true;

          if (this.supportsCssTransitions) {
            this.$activeTabPanel.one(this.transitionEndEvent, showNewPanel);
          } else {
            setTimeout(showNewPanel, this.animationDuration);
          }
        } else {
          showNewPanel();
        }
      } else {
        this.$activeTabPanel.slideUp();
        this.$activeTabPanel.removeClass(ACTIVE_CLASS);
        $panel.slideDown();
        $panel.addClass(ACTIVE_CLASS);
        this.$activeTab = $tab;
        this.$activeTabPanel = $panel;
      }
    }

    deactivate() {
      this.$tabs.removeClass(ACTIVE_CLASS).parent().removeClass(ACTIVE_CLASS);
      this.$tabPanels.removeClass(ACTIVE_CLASS);
      this.$activeTab = undefined;
      this.$activeTabPanel = undefined;
      this.isAnimating = false;
    }

    onTabClick(event) {
      event.preventDefault();
      this.activate($(event.currentTarget));
      this.$tabsList.toggleClass('expanded');
    }
  }

  $(document).on('click.tabs', SELECTORS.tabToggle, function (event) {
    event.preventDefault();

    const $container = $(this).parents(SELECTORS.container);
    let tabs = $container.data('tabs');

    if (!tabs) {
      tabs = new Tabs($container);
      $container.data('tabs', tabs);
      tabs.activate($(event.currentTarget));
    }
  });

  class FaqTabs extends HTMLElement {
    constructor() {
      super();
      new Tabs($(SELECTORS.tabContainer));
      this.embedVideo();
    }

    embedVideo() {
      const videoLinks = document.querySelectorAll(SELECTORS.videoLink);
      const videoModal = document.querySelector(SELECTORS.videoModal);
      const videoModalInner = document.querySelector(SELECTORS.videoModalInner);
      const closeButton = document.querySelector(SELECTORS.closeModal);

      if (closeButton) {
        closeButton.addEventListener('click', () => {
          const iframe = videoModalInner.querySelector('iframe');
          if (iframe) iframe.src = '';
          videoModal.classList.add('hidden');
        });
      }

      videoLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          videoModalInner.innerHTML = `<iframe id="video-modal" src="${link.href}&autoplay=1" allow="autoplay; encrypted-media" allowfullscreen></iframe>`;
          videoModal.classList.remove('hidden');
        });
      });
    }
  }

  customElements.define('faq-tabs', FaqTabs);
})(jQuery);
